import { h, Component } from 'preact'
import { getDefinition } from '../annotations/definition_provider'
import { PLAYER_CONTROL_EVENT, PLAYER_EVENT, ANNOTATION_EVENT, APPLICATION_EVENT } from 'constants/events'
import { removePunctuation } from 'utilities/parsers'
import { PowerWordDefinition } from '../components/power_word_definition'
import { accessible } from 'utilities/accessibility'


export const powerwordable = Annotation => class extends Annotation {
    constructor(props) {
        super(props)
        this.state = {
            powerWords: [],
            definitionActive: false,
            currentDefinition: "",
        }
        this.currentTime = 0
        this.props.eventBus.on(PLAYER_EVENT.TIME_UPDATE, (e,p) => this.onTimeUpdate(e, p))
        this.props.eventBus.on(ANNOTATION_EVENT.POWER_WORD_DEFINITON_OPENED, (id) => this.shouldCloseCurrentCaption(id))
        this.props.eventBus.on(APPLICATION_EVENT.LEVEL_CHANGED, this.onLevelChanged)
        this.props.eventBus.on(APPLICATION_EVENT.SET_STATE, (e) => this.onStateChange(e))
    }

    shouldCloseCurrentCaption = (clickedId) => {
        const { id = null } = this.props; 

        if (clickedId !== id) {
            this.setState({
                definitionActive: false
            })
        }
    }

    onStateChange = (e) => {
        if (e !== "language" ) {
            return;
        } else {
            this.setState({ 
                definitionActive: false 
            })
        }
    }

    onLevelChanged = () => {
        this.setState({
            definitionActive: false
        })
    }

    checkForPowerWords = (content) => {
        let isPowerWord;
        const { powerWords = [] } = this.props; 

        if (!powerWords.length) {
            return; 
        }
        
        powerWords.forEach(w => {
            let words = [];
            if (content.toLowerCase().includes(removePunctuation(w).toLowerCase())) {
                isPowerWord = true;
            }
        })
        
        return isPowerWord;
    }

    onTimeUpdate = (e, p) => {
        const { currentTime } = p;
        const { endTime, expanded } = this.props; 
        this.currentTime = currentTime * 1000

        if (this.currentTime >= endTime && !expanded) {
            this.setState({
                definitionActive: false
            })
        }
    }

    onPowerWordClick = (word, e) => {
        const { eventBus, expanded, containsSearchResults, startTime, endTime, target, id = null } = this.props;

        if (containsSearchResults) {
            e.stopPropagation();
            this.props.eventBus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, startTime / 1000) 
        }

        setTimeout(() => {
            eventBus.emit(PLAYER_CONTROL_EVENT.PAUSE)
        }, 250) //for now, because we need to override the onclick behavior of the li which is to seek and play. 

        this.setState({
            currentWord: word,
            definitionActive: true
        })

        if (expanded || target !== "player") {
            eventBus.emit(ANNOTATION_EVENT.POWER_WORD_DEFINITON_OPENED, id)
        }
    }

    onCloseDefinition = (e) => {
        const { eventBus, target, expanded } = this.props; 

        this.setState({
            definitionActive: false
        })

        if (expanded && target !== 'player') {
            //want to return before call to play if expanded view in player overlay is viewed
            //and overrride the call to seek and play video
            e.stopPropagation();
            eventBus.emit(PLAYER_CONTROL_EVENT.PLAY); 
        } else if (expanded && target === 'player') {
            // prevent resuming playback when closing a definition in overlay transcript
            e.stopPropagation(); 
        } else {
            eventBus.emit(PLAYER_CONTROL_EVENT.PLAY) 
        }
    }

    isPowerWord = (w) => {
        const { powerWords = [] } = this.props; 
        return powerWords.includes(w.toLowerCase())
    }

    getWordAttrs = (word) => {
        return {
            ...super.getWordAttrs(word),
            'data-is-power-word': this.isPowerWord(word)
        }
    }

    getAccessibilityAttrs(isPowerWord, word) {
        if (!isPowerWord) {
            return {}
        } else {
            return {
                role: 'link',
                ariaLabel: `power word, ${word}`,
                ...accessible(this.onPowerWordClick.bind(this, word))   
            }
        }

    }
    powerWordContent(content) {
        const { props } = content;
        let { children } = props;
        const childElements = typeof children === "string" ? children : content.props["data-content"]
        
        content.props.children = (
            childElements.split(' ').map(w => {
                const regExWord = removePunctuation(w);
                const isPowerWord = this.isPowerWord(regExWord);
                const attrs = {
                    ...this.getWordAttrs(regExWord),
                    ...this.getAccessibilityAttrs(isPowerWord, regExWord),
                    onClick: isPowerWord ? this.onPowerWordClick.bind(this, regExWord) : null, 
                }
                return <span><span {...attrs}>{w}</span>{" "}</span>
            })
        )

        return content;
    }

    render() {
        let renderableContent = super.render();
        const { currentDefinition, definitionActive, currentWord = "" } = this.state;
        const { expanded } = this.props;

        if (currentDefinition) {
            player.pause();
        }

        if (this.checkForPowerWords(this.props.content)) {
            renderableContent = this.powerWordContent(renderableContent)
        }

        return !definitionActive 
                ? renderableContent 
                : <PowerWordDefinition 
                    renderableContent={renderableContent}
                    currentWord={currentWord}
                    currentWordDefinition={getDefinition(currentWord)}
                    onCloseDefinition={this.onCloseDefinition}
                    expanded={expanded}
                />

    }
}
